/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_copy_item_to_clipboard_error24 = /** @type {(inputs: {}) => string} */ () => {
	return `An error was encountered while copying item to clipboard`
};

const fr_copy_item_to_clipboard_error24 = /** @type {(inputs: {}) => string} */ () => {
	return `Une erreur s'est produite lors de la copie de l'élément dans le presse-papiers`
};

const de_copy_item_to_clipboard_error24 = /** @type {(inputs: {}) => string} */ () => {
	return `Beim Kopieren des Elements in die Zwischenablage ist ein Fehler aufgetreten`
};

const es_copy_item_to_clipboard_error24 = /** @type {(inputs: {}) => string} */ () => {
	return `Se encontró un error al copiar el elemento al portapapeles`
};

const it_copy_item_to_clipboard_error24 = /** @type {(inputs: {}) => string} */ () => {
	return `Si è verificato un errore durante la copia dell'elemento negli appunti`
};

const ar_copy_item_to_clipboard_error24 = /** @type {(inputs: {}) => string} */ () => {
	return `تم مواجهة خطأ أثناء نسخ العنصر إلى الحافظة`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const copy_item_to_clipboard_error24 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.copy_item_to_clipboard_error24(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("copy_item_to_clipboard_error24", locale)
	if (locale === "en") return en_copy_item_to_clipboard_error24(inputs)
	if (locale === "fr") return fr_copy_item_to_clipboard_error24(inputs)
	if (locale === "de") return de_copy_item_to_clipboard_error24(inputs)
	if (locale === "es") return es_copy_item_to_clipboard_error24(inputs)
	if (locale === "it") return it_copy_item_to_clipboard_error24(inputs)
	return ar_copy_item_to_clipboard_error24(inputs)
};
export { copy_item_to_clipboard_error24 as "COPY_ITEM_TO_CLIPBOARD_ERROR" }